module.exports = __webpack_public_path__ + "static/media/Calender.e2cffac6.svg";